import { Box, styled } from "@mui/material";
import { FC, ReactNode } from "react";
import Logo from "./Logo";
import useSettings from "../../hooks/useSettings";

const BrandRoot = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px 18px 20px 29px"
}));

interface BrandProps {
  children?: ReactNode;
}

const Brand: FC<BrandProps> = ({ children }) => {
  const { settings } = useSettings();
  const leftSidebar = settings.sleekLayoutSettings.leftSidebar!;
  const { mode } = leftSidebar;

  return (
    <BrandRoot>
      <Box display="flex" alignItems="center">
        <Logo />
      </Box>
      <Box className="sidenavHoverShow" sx={{ display: mode === "compact" ? "none" : "block" }}>
        {children || null}
      </Box>
    </BrandRoot>
  );
};

export default Brand;